import * as Yup from 'yup';

const emailValidator = (t: (key: string) => string) => Yup.string().trim().email(t('sing.in.error.email.not.valid')).required(t('sing.in.error.email.is.required'));

export default emailValidator;
